module.exports = __webpack_public_path__ + "media/images/sp/specials/common/plan_gardenchapel-8524c0dffd7a62901c8ba84fc0fb88e6.jpg";